import { useParams } from "react-router-dom";
import { DEFAULT_SECTION, isSectionKey } from "./hashConfig";
import { DemoNav } from "./DemoNav";
import { MasterDetailLayout } from "./MasterDetailLayout";
import { SingleLayout } from "./SingleLayout";
import { SECTION_CONFIG, isMasterDetail } from "./sectionConfig";

export const PagesLeadManagerUiDisplay = () => {
  const { section } = useParams<{ section?: string }>();
  const activeSection = isSectionKey(section) ? section : DEFAULT_SECTION;
  const config = SECTION_CONFIG[activeSection];

  if (isMasterDetail(config)) {
    return (
      <MasterDetailLayout
        DetailComponent={config.DetailComponent}
        ListComponent={config.ListComponent}
        // TODO: replace DemoNav with the real empty-detail state once the feature is built
        emptyState={<DemoNav />}
        key={activeSection}
      />
    );
  }

  return <SingleLayout Component={config.Component} key={activeSection} />;
};
